import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle2 } from 'lucide-react';
import Footer from '../components/Footer';

const DeleteAccountScheduled = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
        <link rel="canonical" href="https://www.lingu-pix.app/delete-account/scheduled" />
        <title>Deletion Scheduled – LinguPix</title>
        <meta name="robots" content="noindex, nofollow" />

      {/* Header */}
      <header className="bg-[#333333] text-white py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center text-[#FFA55A] hover:text-white transition-colors mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Home
          </Link>
          <h1 className="text-4xl font-bold">Account Deletion</h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex-1 flex items-start justify-center">
        <div className="bg-white border-2 border-[#4CAF50]/20 rounded-2xl p-8 text-center space-y-6 w-full max-w-xl">
          <div className="w-20 h-20 bg-[#4CAF50]/10 rounded-full flex items-center justify-center mx-auto">
            <CheckCircle2 size={40} className="text-[#4CAF50]" />
          </div>

          <h2 className="text-2xl font-bold text-[#333333]">
            Deletion scheduled
          </h2>

          <div className="space-y-3 max-w-lg mx-auto">
            <p className="text-[#666666] leading-relaxed">
              Your deletion request has been scheduled successfully.
              All access has been revoked. Permanent deletion is scheduled
              after the account deletion grace period.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default DeleteAccountScheduled;
